import LogoSmall from '@/app/_assets/logos/logo-small.svg';
import Logo from '@/app/_assets/logos/logo.svg';

/**
 * Footer Additional Content Bottom
 *
 * This component is project-specific and will be loaded dynamically
 * in the shared footer. If this file doesn't exist in a project,
 * the footer will gracefully render nothing in its place.
 */
export function FooterAdditionalContentBottom() {
  return (
    <aside className="mx-auto max-w-page bg-background text-foreground">
      {/* eslint-disable-next-line no-restricted-syntax -- R9: one-off logo max-width fit, not a reusable design token */}
      <Logo className="hidden max-w-[74%] lg:block" />
      <LogoSmall className="mx-auto max-w-xs lg:hidden" />
    </aside>
  );
}
